module.exports = __webpack_public_path__ + "img/背景.e132d04c.jpg";